import React, { useState } from 'react';
import {
  ThemeProvider,
  createTheme,
  CssBaseline,
  Container,
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  alpha,
  Snackbar,
  Alert,
  useTheme,
} from '@mui/material';
import {
  School as SchoolIcon,
  AssignmentInd as StudentIcon,
  Receipt as ReceiptIcon,
  TransferWithinAStation as TransferIcon,
  Verified as VerifiedIcon,
  Badge as TeacherBadgeIcon,
  WorkspacePremium as CertificateIcon,
  AttachMoney as SalaryIcon,
  Email as EmailIcon,
  QrCodeScanner as QrScannerIcon,
  TableChart as ExcelIcon,
  CalendarToday as CalendarIcon,
  MenuBook as LessonIcon,
  Edit as ExamIcon,
  Chat as ChatIcon,
  CheckCircle as CheckIcon,
  Close as CloseIcon,
  RemoveCircleOutline as PartialIcon,
  QrCode as QrCodeIcon,
  Print as PrintIcon,
  Lock as LockIcon,
  People as PeopleIcon,
  Class as ClassIcon,
  CreditCard as CreditCardIcon,
  AssignmentTurnedIn as AssignmentIcon,
  Login as LoginIcon,
  Logout as LogoutIcon,
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  Subscriptions as SubscriptionIcon,
  PeopleAlt as CapacityIcon,
  Discount as DiscountIcon,
  CheckCircleOutline as FeatureIcon,
  PictureAsPdf,
  ContactMail as ContactMailIcon,
  Info,
  // Download as DownloadIcon,
  // AccountCircle as AccountIcon,
  // BusinessCenter as BusinessIcon,
  // Dashboard as DashboardIcon,
  // CloudDownload as CloudDownloadIcon,
  // SchoolOutlined as SchoolOutlinedIcon,
  // History as HistoryIcon,
  // Map as MapIcon,
  // Notifications as NotificationsIcon,
  // Security as SecurityIcon,
  // Person as PersonIcon,
  // CreditCard as IdCardIcon,
  // Description as DescriptionIcon,
  // Star as StarIcon,
  // GridOn as TableIcon,
  // WorkspacePremium as PremiumIcon,
  // Payments as PaymentsIcon,
  // Badge as BadgeIcon,
  // AccountBalanceWallet as WalletIcon,
  // FilePresent as FileIcon,
  // CameraAlt as CameraIcon,
  // CloudUpload as CloudUploadIcon,
  // Shield as ShieldIcon,
  // ChevronLeft as ChevronLeftIcon,
  // ChevronRight as ChevronRightIcon,
  // PlayCircle as PlayCircleIcon,
  // Videocam as VideocamIcon,
  // School as GraduationCapIcon,
  // Fingerprint as FingerprintIcon,
  // PersonAdd as PersonAddIcon,
  // LocalOffer as LocalOfferIcon,
  // ContentCopy as ContentCopyIcon,
  // Event as EventIcon,
  // LocalAtm as PriceIcon,
  // EventAvailable as DurationIcon,
} from '@mui/icons-material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { getDeviceInfo } from '../utils/deviceInfo';
import AuthService from '../Auth/AuthService';
import axios from 'axios';
import { useRef } from 'react';
import Logo from "../assets/logo-round-jmk.png";
import LogoDark from "../assets/dark-logo-round-jmk.png";
import { useEffect } from 'react';
import { useMemo } from 'react';
import { createContext } from 'react';
import AuthDialog from './AuthDialog';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import OfferLetterGenerator from '../emp-card/OfferLetterGenerator';
import ImageToPDFConverter from '../emp-card/ImageToPDFConverter';
import ModalView from '../model/ModelView';
import ContactForm from './ContactForm';
import AboutUs from './AboutUs';
import CheckResultPage from './CheckResultPage';

// Create a custom theme
// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1a4a6f',
//       dark: '#0b2b40',
//     },
//     secondary: {
//       main: '#ffb347',
//     },
//     background: {
//       default: '#f4f7fc',
//       paper: '#ffffff',
//     },
//     text: {
//       primary: '#1e2a3e',
//     },
//   },
//   typography: {
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     h1: {
//       fontWeight: 700,
//       letterSpacing: '-0.01em',
//     },
//     h2: {
//       fontWeight: 700,
//       fontSize: '1.7rem',
//     },
//     body1: {
//       fontSize: '0.9rem',
//     },
//   },
//   shape: {
//     borderRadius: 12,
//   },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           transition: 'all 0.25s ease',
//           border: '1px solid #e2edf2',
//           boxShadow: '0 8px 20px rgba(0,0,0,0.03)',
//           '&:hover': {
//             transform: 'translateY(-5px)',
//             boxShadow: '0 20px 30px -12px rgba(0,0,0,0.1)',
//             borderColor: '#cbdde6',
//           },
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 30,
//           textTransform: 'none',
//         },
//       },
//     },
//   },
// });

// Helper to format duration
const formatDuration = (days) => {
  if (days === 365) return 'Yearly';
  if (days === 28) return 'Monthly';
  if (days === 30) return 'Monthly';
  return `${days} days`;
};

// Create Theme Context
const ColorModeContext = createContext({ toggleColorMode: () => { } });
// Data for student cards
const studentCards = [
  {
    icon: <CreditCardIcon />,
    title: 'Student ID Card',
    tag: 'Bulk print',
    features: [
      'Dynamic template: photo, class, blood group, barcode/QR',
      'Bulk generation for sections & classes',
      'QR for instant verification & parent contact',
    ],
  },
  {
    icon: <AssignmentIcon />,
    title: 'Marksheet',
    tag: 'CGPA/Percentage',
    features: [
      'Term-wise, cumulative, rank & grade analysis',
      'Subject-wise analytics & performance trends',
      'Bulk report card generation',
    ],
  },
  {
    icon: <ReceiptIcon />,
    title: 'Fees Slip',
    tag: null,
    features: [
      'Automated slip with due date & late fine',
      'Real-time ledger: paid / partial / unpaid',
      'Bulk fee receipts & online payment gateway sync',
    ],
  },
  {
    icon: <TransferIcon />,
    title: 'Transfer Certificate (TC)',
    tag: null,
    features: [
      'Board-compliant format (CBSE/ICSE/State)',
      'One-click generation locks student status → "Transferred"',
      'Digital signature & seal support',
    ],
  },
  {
    icon: <VerifiedIcon />,
    title: 'Bonafide & Character Cert.',
    tag: null,
    features: [
      'Instant bonafide for scholarships, passport, licenses',
      'Character certificate with discipline log integration',
      'Self-service download for parents/students',
    ],
  },
];

// Data for teacher cards
const teacherCards = [
  {
    icon: <TeacherBadgeIcon />,
    title: 'Teacher ID Card',
    tag: 'QR enabled',
    features: [
      'Photo, designation, department, employee code',
      'QR code scanning → instant profile & employment status',
      'Bulk print for staff',
    ],
  },
  {
    icon: <CertificateIcon />,
    title: 'Experience Certificate',
    tag: 'QR verifiable',
    features: [
      'Tamper-proof PDF with unique hash & QR',
      'Future employer scans to verify tenure & designation',
      'Stored in central ledger for authenticity',
    ],
  },
  {
    icon: <SalaryIcon />,
    title: 'Salary Slip · Monthly',
    tag: null,
    features: [
      'Auto payroll with HRA, allowances, deductions, TDS',
      'Teachers login → view/download own slips',
      'Bulk slip generation for accounts dept',
    ],
  },
  {
    icon: <EmailIcon />,
    title: 'Offer Letter / Appointment',
    tag: null,
    features: [
      'Merge fields: name, salary, role, joining date',
      'Digital signature ready, printable offer letters',
      'Version tracking & HR approval flow',
    ],
  },
  {
    icon: <QrScannerIcon />,
    title: 'Attendance (Scan QR Code)',
    tag: null,
    features: [
      'Teachers mark presence via dynamic QR at reception / app',
      'Geo-fencing & real-time dashboard',
      'Late arrival alerts & monthly attendance summary',
    ],
  },
  {
    icon: <ExcelIcon />,
    title: 'Bulk Teacher Import · Excel',
    tag: null,
    features: [
      'Upload CSV/XLSX → auto-create profiles & login credentials',
      'Auto email with username/password to new teachers',
      'Reduces manual entry time by 90%',
    ],
  },
];

// Data for class management cards
const classMgmtCards = [
  {
    icon: <CalendarIcon />,
    title: 'Timetable & Scheduling',
    features: [
      'Auto-scheduler (no teacher/room conflicts)',
      'Substitute teacher suggestion on absence',
    ],
  },
  {
    icon: <LessonIcon />,
    title: 'Lesson Plan & Syllabus',
    features: [
      'Unit planner with progress tracking',
      'Upload resources, assignments, digital library',
    ],
  },
  {
    icon: <ExamIcon />,
    title: 'Exam Management',
    features: [
      'Seating arrangement generator, hall tickets',
      'Marks entry portal with grade locking',
    ],
  },
  {
    icon: <ChatIcon />,
    title: 'Communication Hub',
    features: [
      'Parent-teacher meeting scheduler',
      'Broadcast announcements & class groups',
    ],
  },
];

// RBAC Table Data
const rbacData = [
  {
    role: 'Admin',
    studentDocs: '✔ Full access',
    teacherFinancials: '✔ Salary slips, all fees',
    certificates: '✔ Generate/Revoke any',
    attendanceBulk: '✔ Full import, config',
    studentIcon: <CheckIcon color="success" fontSize="small" />,
    teacherIcon: <CheckIcon color="success" fontSize="small" />,
    certIcon: <CheckIcon color="success" fontSize="small" />,
    bulkIcon: <CheckIcon color="success" fontSize="small" />,
  },
  {
    role: 'Principal',
    studentDocs: '✔ View/Generate all',
    teacherFinancials: '✘ No salary edit',
    certificates: '✔ TC, Exp certs',
    attendanceBulk: '✔ View staff attendance',
    studentIcon: <CheckIcon color="success" fontSize="small" />,
    teacherIcon: <CloseIcon color="error" fontSize="small" />,
    certIcon: <CheckIcon color="success" fontSize="small" />,
    bulkIcon: <CheckIcon color="success" fontSize="small" />,
  },
  {
    role: 'Accountant',
    studentDocs: 'Fee slips only',
    teacherFinancials: '✔ Salary slip & payroll',
    certificates: '✘ No TC/Experience',
    attendanceBulk: '✘ No bulk teacher import',
    studentIcon: <PartialIcon color="warning" fontSize="small" />,
    teacherIcon: <CheckIcon color="success" fontSize="small" />,
    certIcon: <CloseIcon color="error" fontSize="small" />,
    bulkIcon: <CloseIcon color="error" fontSize="small" />,
  },
  {
    role: 'Class Teacher',
    studentDocs: 'Own class only (bonafide, marksheet)',
    teacherFinancials: '✘ No salary access',
    certificates: 'Character cert (own class)',
    attendanceBulk: '✔ Class attendance',
    studentIcon: <PartialIcon color="warning" fontSize="small" />,
    teacherIcon: <CloseIcon color="error" fontSize="small" />,
    certIcon: <PartialIcon color="warning" fontSize="small" />,
    bulkIcon: <CheckIcon color="success" fontSize="small" />,
  },
  {
    role: 'Teacher (self)',
    studentDocs: '✘',
    teacherFinancials: '✔ Own salary slip',
    certificates: '✔ Own experience cert',
    attendanceBulk: '✔ Self QR attendance',
    studentIcon: <CloseIcon color="error" fontSize="small" />,
    teacherIcon: <CheckIcon color="success" fontSize="small" />,
    certIcon: <CheckIcon color="success" fontSize="small" />,
    bulkIcon: <CheckIcon color="success" fontSize="small" />,
  },
  {
    role: 'Student/Parent',
    studentDocs: 'View ID, marksheet, fees',
    teacherFinancials: '✘',
    certificates: 'Download Bonafide/TC (if released)',
    attendanceBulk: '✘',
    studentIcon: <CheckIcon color="success" fontSize="small" />,
    teacherIcon: <CloseIcon color="error" fontSize="small" />,
    certIcon: <PartialIcon color="warning" fontSize="small" />,
    bulkIcon: <CloseIcon color="error" fontSize="small" />,
  },
];

// Helper component for feature list
const FeatureList = ({ features }) => (
  <List dense disablePadding>
    {features.map((feature, idx) => (
      <ListItem key={idx} disablePadding sx={{ mb: 0.5 }}>
        <ListItemIcon sx={{ minWidth: 28 }}>
          <CheckIcon sx={{ fontSize: 16, color: '#2c7da0' }} />
        </ListItemIcon>
        <ListItemText primary={feature} slotProps={{ primary: { fontSize: '0.85rem' } }} />
      </ListItem>
    ))}
  </List>
);

// Card component for modules
const FeatureCard = ({ icon, title, tag, features }) => (
  <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', px: '1rem' }}>
    <CardContent>
      <Avatar
        sx={{
          bgcolor: '#eef4fa',
          color: '#1f6392',
          width: 55,
          height: 55,
          borderRadius: 2,
          mb: 2,
        }}
      >
        {icon}
      </Avatar>
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 1 }}>
        <Typography variant="h6" component="h3" fontWeight={700}>
          {title}
        </Typography>
        {tag && (
          <Chip
            label={tag}
            size="small"
            sx={{
              bgcolor: tag.includes('QR') ? '#2c7da0' : '#eef2f5',
              color: tag.includes('QR') ? 'white' : '#1e2a3e',
              fontWeight: 600,
              fontSize: '0.70rem',
              height: 22,
            }}
          />
        )}
      </Box>
      <FeatureList features={features} />
    </CardContent>
  </Card>
);

// Hero Component
const Hero = () => {
  // const navigate = useNavigate();
  const theme = useTheme();
  // const colorMode = useContext(ColorModeContext); 

  return (
    // <Box sx={{ bgcolor: 'background.default' }}>
    <Box //sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '1.5rem' }}
    >
      <Box
        sx={{
          // background: 'linear-gradient(135deg, #0b2b40 0%, #1a4a6f 100%)',
          borderRadius: 2,
          p: { xs: 2, md: 3 },
          mb: 3,
          // color: 'white',
          // boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
          border: '1px solid #cde3ed',
          '&:hover': { boxShadow: '2px 2px 30px -12px rgba(0,0,0,0.1)', border: '1px solid #a9dcf3' }
        }}
      >
        <Stack direction="row" spacing={2} //alignItems="center"
        >
          <Avatar sx={{ bgcolor: '#ffb347', width: 56, height: 56 }}>
            <SchoolIcon sx={{ color: '#1e2a3e' }} />
          </Avatar>
          <Box py={1}>
            <Typography variant="h4" component="h1" fontWeight={900} fontFamily={'sans-serif'}>
              SCHOOL ERP
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9, maxWidth: '80%', mt: 0.5 }}>
              A complete school management platform for admissions, attendance, examinations, fee collection, staff management, ID cards, marksheets, QR-verified certificates, salary slips, and secure role-based access.
            </Typography>
            <Box>
              <Chip
                icon={<LockIcon color='darkblue'
                />}
                label="Role-Based Access Control (RBAC)"
                sx={{
                  mt: 1, bgcolor: 'rgba(3, 181, 246, 0.2)', mr: 1, color: theme.palette.text.primary, fontWeight: 600,
                  borderRadius: 4
                }}
              />
              <Chip
                icon={<QrCodeIcon color='green'
                />}
                label="QR Verifiable Documents"
                sx={{
                  mt: 1, bgcolor: 'rgba(51, 255, 0, 0.2)', ml: 1, color: theme.palette.text.primary, fontWeight: 600,
                  borderRadius: 4
                }}
              />
            </Box>
          </Box>
        </Stack>
      </Box>
    </Box>
    // </Box>
  )
};

// Section Title Component
const SectionTitle = ({ icon, title }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, mt: 4, borderLeft: '6px solid #2c7da0', pl: 1 }}>
    {icon && <Avatar sx={{ bgcolor: '#eef4fa', color: '#1f6392', width: 32, height: 32 }}>{icon}</Avatar>}
    <Box >
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ color: '#0f3b4c' }}>
        {title}
      </Typography>
    </Box>
  </Box>
);

// QR Demo Component with interactive simulation
const QrDemo = () => {
  const [verified, setVerified] = useState(false);

  const handleSimulate = () => setVerified(true);
  const handleReset = () => setVerified(false);

  return (
    <Paper
      elevation={0}
      sx={{
        // bgcolor: '#fef9e6',
        borderLeft: '6px solid #ffb347',
        borderTop: '2px solid lightgray',
        borderRight: '2px solid lightgray',
        borderBottom: '2px solid lightgray',
        borderRadius: 2,
        p: 2,
        mb: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <Box sx={{ textAlign: 'center', bgcolor: 'white', p: 1, borderRadius: 2, width: 80 }}>
          <QrCodeIcon sx={{ fontSize: 48, color: '#1f6392' }} />
          <Typography variant="caption" display="block">
            VERIFY-EXP-101
          </Typography>
        </Box>
        <Box>
          <Typography fontWeight={700}>
            <TeacherBadgeIcon sx={{ fontSize: 16, mr: 0.5 }} /> Teacher: Mr. Brijsen Khutiyare
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Experience Certificate · 5 years (2019-2024)
          </Typography>
          <Paper
            variant="outlined"
            sx={{
              mt: 1,
              p: 0.5,
              px: 1,
              bgcolor: verified ? '#e0f2e9' : '#eef2fa',
              borderLeft: verified ? '3px solid #2b8c4a' : 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            {verified ? (
              <>
                <CheckIcon sx={{ fontSize: 16, color: '#2b8c4a' }} />
                <Typography variant="caption">
                  ✅ VERIFIED: Authentic Experience Certificate — Brijsen Khutiyare, Mathematics Dept, tenure: 2019-2024. (QR hash: 0x7f3e9a2b)
                </Typography>
              </>
            ) : (
              <>
                <Typography variant="caption">
                  <i>Not verified — click simulate scan</i>
                </Typography>
              </>
            )}
          </Paper>
        </Box>
      </Box>
      <Stack direction="row" spacing={1}>
        <Button
          variant="contained"
          size="small"
          startIcon={<QrScannerIcon />}
          onClick={handleSimulate}
          sx={{ bgcolor: '#2c7da0', '&:hover': { bgcolor: '#1f6392' } }}
        >
          Simulate QR Scan
        </Button>
        <Button variant="outlined" size="small" onClick={handleReset} sx={{ color: '#6c757d', borderColor: '#6c757d' }}>
          Reset
        </Button>
      </Stack>
    </Paper>
  );
};

// RBAC Table Component
const RbacTable = () => (
  <TableContainer component={Paper} sx={{ borderRadius: 1, overflowX: 'auto', mb: 3 }}>
    <Table sx={{ minWidth: 650 }}>
      <TableHead sx={{ bgcolor: '#e9f0f5' }}>
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>Role</TableCell>
          <TableCell sx={{ fontWeight: 700 }}>Student Docs</TableCell>
          <TableCell sx={{ fontWeight: 700 }}>Teacher Financials</TableCell>
          <TableCell sx={{ fontWeight: 700 }}>Certificates (TC/Exp)</TableCell>
          <TableCell sx={{ fontWeight: 700 }}>Attendance & Bulk Ops</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rbacData.map((row) => (
          <TableRow key={row.role} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
              {row.role}
            </TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {row.studentIcon} {row.studentDocs}
              </Box>
            </TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {row.teacherIcon} {row.teacherFinancials}
              </Box>
            </TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {row.certIcon} {row.certificates}
              </Box>
            </TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {row.bulkIcon} {row.attendanceBulk}
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

// Bulk Operations Banner
const BulkOperations = ({ onSuccess }) => (
  <Paper
    elevation={0}
    sx={{
      background: 'linear-gradient(120deg, #eef2fa, white)',
      borderRadius: 1,
      p: 2.5,
      mt: 3,
      mb: 3,
      border: '1px solid #cde3ed',
      '&:hover': { boxShadow: '2px 2px 30px -12px rgba(0,0,0,0.1)', border: '1px solid #a9dcf3' }
    }}
  >
    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" spacing={2}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ExcelIcon sx={{ fontSize: 32, color: '#1f6392' }} />
        <Box>
          <Typography fontWeight={700}>Bulk Operations</Typography>
          <Typography variant="body2" color="text.secondary">
            ✔ Generate 500 ID cards / marksheets in one click ✔ Excel export/import for teachers, students ✔ Bulk TC, salary slip generation with print merge
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} onClick={() => { if (onSuccess) onSuccess() }} >
        <ContactMailIcon sx={{ fontSize: 32, color: '#1f6392' }} />
        <Typography fontWeight={700}>Contact Us</Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', }}>
        <PrintIcon sx={{ fontSize: 32, color: '#2c7da0' }} />
        <Box>
          <Typography fontWeight={700}>Multi-format</Typography>
          <Typography variant="body2" color="text.secondary">
            PDF, CSV, thermal print, A4, PVC card support
          </Typography>
        </Box>
      </Box>
    </Stack>
  </Paper>
);

// Footer
const Footer = () => (
  <Box component="footer" sx={{ textAlign: 'center', py: 3, borderTop: '1px solid #cbdde6', mt: 2 }}>
    <Typography variant="caption" color="text.secondary">
      <LockIcon sx={{ fontSize: 12, mr: 0.5 }} /> Secure, QR‑verifiable certificates · Granular Role-Based Access · Real-time sync between student & teacher modules
    </Typography>
  </Box>
);

// Helper to format price
const formatPrice = (price) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'inr',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(price);
};

// Subscription Plan Card Component
const PlanCard = ({ plan }) => {
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const isActive = plan.active;
  const discountedPrice = getDiscountedPrice(plan);
  const discountType = plan.couponDTO?.discountType;
  const discountValue = discountType === 'PERCENTAGE'
    ? `${plan.couponDTO.discountPercentage}%`
    : discountType === 'FLAT'
      ? formatPrice(plan.couponDTO.discountAmount)
      : null;

  const handleLogin = (plan) => {
    console.log("check login", plan);
    setSnackbar({
      open: true,
      // message: 'Please log in to continue.',
      message: 'Please log in to proceed with your purchase.',
      severity: 'info'
    });
    // navigate('/checkout', {
    //   state: { plan: plan, coupon: null }
    // });
  }

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Card
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          opacity: isActive ? 1 : 0.7,
          transition: 'all 0.2s',
          '&:hover': { transform: isActive ? 'translateY(-4px)' : 'none', boxShadow: isActive ? 4 : 1 }
        }}
      >
        {!isActive && (
          <Chip
            label="Coming Soon"
            color="warning"
            size="small"
            sx={{ position: 'absolute', top: 12, right: 12 }}
          />
        )}
        <CardContent>
          {/* Plan Name & Popular Badge */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
            <Typography variant="h6" component="h3" fontWeight={700}>
              {plan.name}
            </Typography>
            {plan.popular && <Chip label="Popular" color="secondary" size="small" />}
          </Box>

          {/* Price */}
          <Box sx={{ display: 'flex', alignItems: 'baseline', mb: 0.5 }}>
            <Typography variant="h4" component="span" fontWeight={700}>
              {discountedPrice ? formatPrice(discountedPrice) : formatPrice(plan.price)}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
              / {formatDuration(plan.durationInDays)}
            </Typography>
          </Box>
          {discountedPrice && (
            <Typography variant="caption" color="error" sx={{ textDecoration: 'line-through', mr: 1 }}>
              {formatPrice(plan.price)}
            </Typography>
          )}

          {/* Description */}
          {/* <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
          {plan.description}
        </Typography> */}

          {/* Capacities */}
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <Chip
              icon={<CapacityIcon />}
              label={`${plan.stdCount} students`}
              size="small"
              variant="outlined"
            />
            <Chip
              icon={<PeopleIcon />}
              label={`${plan.empCount} teachers`}
              size="small"
              variant="outlined"
            />
          </Box>

          {/* Features */}
          <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
            Features:
          </Typography>
          <List dense disablePadding>
            {plan.features.map((feature, idx) => (
              <ListItem key={idx} disablePadding sx={{ mb: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 28 }}>
                  <FeatureIcon sx={{ fontSize: 16, color: '#2c7da0' }} />
                </ListItemIcon>
                <ListItemText primary={feature} slotProps={{ fontSize: '0.8rem' }} />
              </ListItem>
            ))}
          </List>

          {/* Coupon / Discount */}
          {plan.couponDTO && (
            <Box sx={{ mt: 2, pt: 1, borderTop: '1px solid #e2edf2' }}>
              <Chip
                icon={<DiscountIcon />}
                label={discountType === 'PERCENTAGE' ? `${discountValue} off` : `${discountValue} off`}
                size="small"
                color="success"
                variant="outlined"
              />
              {plan.couponDTO.endDate && (
                <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
                  Valid until {new Date(plan.couponDTO.endDate).toLocaleDateString()}
                </Typography>
              )}
            </Box>
          )}

          {/* Action Button */}
          <Button
            variant="contained"
            fullWidth
            onClick={() => handleLogin(plan)}
            sx={{
              backgroundColor: '#01445ec3', mt: 2, borderRadius: 2,
              '&:hover': { backgroundColor: '#002230' }
            }}
            disabled={!isActive}
          >
            {isActive ? 'Choose Plan' : 'Notify Me'}
          </Button>
        </CardContent>
      </Card>
    </>);
};

// Helper to compute discounted price
const getDiscountedPrice = (plan) => {
  if (!plan.couponDTO) return null;
  const { discountType, discountPercentage, discountAmount } = plan.couponDTO;
  if (discountType === 'PERCENTAGE' && discountPercentage) {
    return plan.price * (1 - discountPercentage / 100);
  }
  if (discountType === 'FLAT' && discountAmount) {
    return Math.max(0, plan.price - discountAmount);
  }
  return null;
};

// Subscription Plans Section Component
const SubscriptionPlans = ({ plans }) => {
  const activePlans = plans.filter(p => p.active).filter(plan => plan.name.includes("Yearly")
    // || plan.name.includes("Basic") || plan.name.includes("Starter") || plan.name.includes("Premium")
  );
  // const allPlans = plans;

  return (
    <>
      <SectionTitle icon={<SubscriptionIcon />} title="Subscription Plans" />
      <Grid container spacing={4}>
        {activePlans
          .map((plan) => (
            <Grid item xs={12} sm={6} md={4} key={plan.id}>
              <PlanCard plan={plan} />
            </Grid>
          ))}
      </Grid>
    </>
  );
};

// Main App Component
function SchoolDashboard() {
  const [mode, setMode] = useState('light');
  const [plans, setPlans] = useState([]);
  const hasFetched = useRef(false);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: {
            main: '#2a80e0',
            light: '#5f9cf0',
            dark: '#0b1926',
          },
          secondary: {
            main: '#f3b33d',
          },
          background: {
            default: mode === 'light' ? '#ffffff' : '#022c47',
            paper: mode === 'light' ? '#ffffff' : '#1e293b',
          },
          text: {
            primary: mode === 'light' ? '#1a2634' : '#ffffff',
            secondary: mode === 'light' ? '#4f6072' : '#b0c4de',
          },
        },
        typography: {
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          h1: {
            fontWeight: 700,
            letterSpacing: '-0.01em',
          },
          h2: {
            fontWeight: 700,
            fontSize: '1.7rem',
          },
          body1: {
            fontSize: '0.9rem',
          },
        },
        shape: {
          borderRadius: 12,
        },
        components: {
          MuiCard: {
            styleOverrides: {
              root: {
                transition: 'all 0.25s ease',
                border: '1px solid #d6edf8',
                boxShadow: '0 8px 20px rgba(0,0,0,0.03)',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 20px 30px -12px rgba(0,0,0,0.1)',
                  borderColor: '#bed2db',
                },
              },
            },
          },
          MuiButton: {
            styleOverrides: {
              root: {
                borderRadius: 30,
                textTransform: 'none',
              },
            },
          },
        },

      }),
    [mode],
  );

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    deviceInfo();
    fetchPlan();
  }, []);

  // device info
  const deviceInfo = async () => {
    try {
      const info = await getDeviceInfo();
      console.log("Device Info:", info);
      localStorage.setItem("device", JSON.stringify(info));
    } catch (error) {
      console.log("Device info error:", error);
    }
  }

  const fetchPlan = async () => {
    axios
      .get(AuthService.pathUrl("GET", "/subscription/plans"))
      .then((res) => {
        setPlans(res?.data || []);
      })
      .catch((error) => {
        console.error("Failed to fetch subscription plans:", error.message);
      })
      .finally(() => {
        // setLoading(false);
      });
  };




  const navigate = useNavigate();
  // const theme = useTheme();
  // const colorMode = useContext(ColorModeContext);
  // Auth state
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  // const [showBar, setShowBar] = useState(true);
  const [authTab, setAuthTab] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleOpenAuth = () => {
    setAuthTab(0);
    setAuthDialogOpen(true);
  };
  const handleCloseAuth = () => {
    setAuthDialogOpen(false);
    setOpen(false);
    setOpenForm(false);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    AuthService.logout();
    setSnackbar({
      open: true,
      message: 'Logged out successfully',
      severity: 'info'
    });
  };


  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container maxWidth="xl" sx={{ py: { xs: 2, md: 3 } }}>
          {/* {showBar && ( */}
          <Box sx={{
            bgcolor: 'background.default',
            position: 'fixed',
            zIndex: '1',
            width: '100%',
            top: 0,
            left: 0,
            right: 0
          }}>
            <AppBar
              position="static"
              color="transparent"
              elevation={0}
              sx={{
                backdropFilter: 'blur(10px)',
                bgcolor: alpha(theme.palette.background.paper, 0.8),
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`
              }}
            >
              <Toolbar sx={{
                flexWrap: 'wrap',
                gap: { xs: 0.5, sm: 1 },
                py: { xs: 0.5, sm: 1 }
              }}>

                {/* Logo */}
                <Typography
                  variant="h4"
                  component="h1"
                  sx={{
                    fontWeight: 300,
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={() => setAuthTab(0)}
                >
                  <img
                    src={theme.palette.mode === 'dark' ? LogoDark : Logo}
                    alt="jmk"
                    width={70}
                  // style={{ background: '#0f253a', borderRadius: 10 }}
                  />
                </Typography>

                {/* Buttons Container */}
                <Stack
                  direction="row"
                  spacing={{ xs: 0.5, sm: 1 }}
                  sx={{
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end'
                  }}
                >
                  {/* Affer Letter Create - Icon only on mobile */}
                  <Button
                    onClick={() => setAuthTab(1)}
                    color={theme.palette.mode === 'dark' ? '#FFF' : '#0f253a'}
                    sx={{
                      borderRadius: 60,
                      minWidth: { xs: 'auto', sm: 'auto' },
                      px: { xs: 1, sm: 2 },
                      '& .MuiButton-startIcon': {
                        margin: { xs: 0, sm: '0 8px 0 -4px' }
                      }
                    }}
                  >
                    <AssignmentIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
                    <Box sx={{ display: { xs: 'none', sm: 'inline' }, ml: 1 }}>
                      Affer Letter Create
                    </Box>
                  </Button>

                  {/* PDF Converter - Icon only on mobile */}
                  <Button
                    onClick={() => setOpen(true)}
                    color={theme.palette.mode === 'dark' ? '#FFF' : '#0f253a'}
                    sx={{
                      borderRadius: 60,
                      minWidth: { xs: 'auto', sm: 'auto' },
                      px: { xs: 1, sm: 2 },
                      '& .MuiButton-startIcon': {
                        margin: { xs: 0, sm: '0 8px 0 -4px' }
                      }
                    }}
                  >
                    <PictureAsPdf sx={{ fontSize: { xs: 20, sm: 24 } }} />
                    <Box sx={{ display: { xs: 'none', sm: 'inline' }, ml: 1 }}>
                      PDF Converter
                    </Box>
                  </Button>

                  {/* about us - Icon only on mobile */}
                  <Button
                    onClick={() => setAuthTab(2)}
                    color={theme.palette.mode === 'dark' ? '#FFF' : '#0f253a'}
                    sx={{
                      borderRadius: 60,
                      minWidth: { xs: 'auto', sm: 'auto' },
                      px: { xs: 1, sm: 2 },
                      '& .MuiButton-startIcon': {
                        margin: { xs: 0, sm: '0 8px 0 -4px' }
                      }
                    }}
                  >
                    <Info sx={{ fontSize: { xs: 20, sm: 24 } }} />
                    <Box sx={{ display: { xs: 'none', sm: 'inline' }, ml: 1 }}>
                      About Us
                    </Box>
                  </Button>

                  {/* Check Result - Icon only on mobile */}
                  <Button
                    onClick={() => setAuthTab(3)
                      // navigate("/result")
                    }
                    color={theme.palette.mode === 'dark' ? '#FFF' : '#0f253a'}
                    sx={{
                      borderRadius: 60,
                      minWidth: { xs: 'auto', sm: 'auto' },
                      px: { xs: 1, sm: 2 },
                      '& .MuiButton-startIcon': {
                        margin: { xs: 0, sm: '0 8px 0 -4px' }
                      }
                    }}
                  >
                    <SchoolIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
                    <Box sx={{ display: { xs: 'none', sm: 'inline' }, ml: 1 }}>
                      Check Result
                    </Box>
                  </Button>

                  {!isAuthenticated ? (
                    <Button
                      onClick={handleOpenAuth}
                      color={theme.palette.mode === 'dark' ? '#FFF' : '#0f253a'}
                      sx={{
                        borderRadius: 60,
                        minWidth: { xs: 'auto', sm: 'auto' },
                        px: { xs: 1, sm: 2 },
                        '& .MuiButton-startIcon': {
                          margin: { xs: 0, sm: '0 8px 0 -4px' }
                        }
                      }}
                    >
                      <LoginIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
                      <Box sx={{ display: { xs: 'none', sm: 'inline' }, ml: 1 }}>
                        Start now
                      </Box>
                    </Button>
                  ) : (
                    <>
                      {/* Dashboard - Hide on mobile */}
                      <Button
                        onClick={() => window.location.reload()}
                        color={theme.palette.mode === 'dark' ? '#FFF' : '#0f253a'}
                        sx={{
                          borderRadius: 60,
                          display: { xs: 'none', sm: 'inline-flex' }
                        }}
                      >
                        Dashboard
                      </Button>

                      {/* User Chip - Hide on mobile */}
                      <Chip
                        avatar={<Avatar>{user?.name?.charAt(0).toUpperCase()}</Avatar>}
                        label={user?.name}
                        variant="outlined"
                        sx={{
                          color: theme.palette.text.primary,
                          display: { xs: 'none', sm: 'inline-flex' }
                        }}
                      />

                      {/* Logout - Icon only on mobile */}
                      <Button
                        onClick={() => handleLogout()}
                        sx={{
                          borderRadius: 60,
                          minWidth: { xs: 'auto', sm: 'auto' },
                          px: { xs: 1, sm: 2 },
                          '& .MuiButton-startIcon': {
                            margin: { xs: 0, sm: '0 8px 0 -4px' }
                          }
                        }}
                      >
                        <LogoutIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
                        <Box sx={{ display: { xs: 'none', sm: 'inline' }, ml: 1 }}>
                          Logout
                        </Box>
                      </Button>
                    </>
                  )}
                </Stack>

                {/* Dark Mode Toggle */}
                <IconButton
                  sx={{
                    ml: { xs: 0.5, sm: 1 },
                    p: { xs: 0.5, sm: 1 }
                  }}
                  onClick={colorMode.toggleColorMode}
                  color="inherit"
                >
                  {theme.palette.mode === 'dark' ?
                    <Brightness7Icon sx={{ fontSize: { xs: 20, sm: 24 } }} /> :
                    <Brightness4Icon sx={{ fontSize: { xs: 20, sm: 24 } }} />
                  }
                </IconButton>
              </Toolbar>
            </AppBar>

            <AuthDialog
              open={authDialogOpen}
              onClose={handleCloseAuth}
              onAuthSuccess={(userData) => {
                setIsAuthenticated(true);
                setUser(userData);
                setSnackbar({ open: true, message: `Welcome ${userData.email}!`, severity: 'success' });
              }}
              initialTab={authTab}
            />
            {/* Snackbar for notifications */}
            <Snackbar
              open={snackbar.open}
              autoHideDuration={4000}
              onClose={handleCloseSnackbar}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                {snackbar.message}
              </Alert>
            </Snackbar>
          </Box>
          {/* )} */}
          {authTab === 0 && (
            <Box marginTop={9}>
              <Hero />
              {/* Student Section */}
              <SectionTitle icon={<StudentIcon />} title="Student Document Hub" />
              <Grid container spacing={4}>
                {studentCards.map((card, idx) => (
                  <Grid item xs={12} sm={6} md={4} key={idx}>
                    <FeatureCard {...card} />
                  </Grid>
                ))}
              </Grid>

              {/* Teacher Section */}
              <SectionTitle icon={<PeopleIcon />} title="Teacher & Staff Management" />
              <Grid container spacing={4}>
                {teacherCards.map((card, idx) => (
                  <Grid item xs={12} sm={6} md={4} key={idx}>
                    <FeatureCard {...card} />
                  </Grid>
                ))}
              </Grid>

              {/* Subscription Plans */}
              <SubscriptionPlans plans={plans} />

              {/* RBAC Section */}
              <SectionTitle icon={<LockIcon />} title="Role‑Based Data Access (RBAC)" />
              <RbacTable />

              {/* QR Demo Section */}
              <SectionTitle icon={<QrCodeIcon />} title="Live QR Verification Demo" />
              <QrDemo />
              <Paper
                elevation={0}
                sx={{
                  bgcolor: '#eef2fa',
                  borderRadius: 2,
                  p: 2,
                  mb: 3,
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CreditCardIcon sx={{ color: '#1f6392' }} />
                  <Typography variant="body2">
                    <strong>Teacher ID Card (QR)</strong> — any school visitor scans QR → shows verified name, department, employment status
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <CheckIcon sx={{ fontSize: 16, color: '#1f8a4c' }} />
                  <Typography variant="caption">Anti-forgery: certificates stored with blockchain hash simulation</Typography>
                </Box>
              </Paper>

              {/* Class Management */}
              <SectionTitle icon={<ClassIcon />} title="Class Management & Smart Operations" />
              <Grid container spacing={4}>
                {classMgmtCards.map((card, idx) => (
                  <Grid item xs={12} sm={6} md={3} key={idx}>
                    <Card sx={{ height: '100%' }}>
                      <CardContent>
                        <Avatar sx={{ bgcolor: '#eef4fa', color: '#1f6392', mb: 2, width: 48, height: 48 }}>
                          {card.icon}
                        </Avatar>
                        <Typography variant="h6" fontWeight={700} gutterBottom>
                          {card.title}
                        </Typography>
                        <FeatureList features={card.features} />
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {/* Bulk Operations */}
              <BulkOperations onSuccess={() => { setOpenForm(true) }} />

            </Box>)}
          {authTab === 1 && (
            <OfferLetterGenerator
              onSuccess={() => {
                //   setShowBar(false);
                setTimeout(() => {
                  setAuthTab(1);
                }, 5000)
              }}
            />
          )}

          {authTab === 2 && (
            <AboutUs
              onSuccess={() => {
                setTimeout(() => {
                  setAuthTab(2);
                }, 5000)
              }}
            />
          )}

          {authTab === 3 && (
            <CheckResultPage
              onSuccess={() => {
                setTimeout(() => {
                  setAuthTab(3);
                }, 5000)
              }}
            />
          )}

          <Footer />
        </Container>
      </ThemeProvider>
      <ModalView
        open={open}
        handleClose={handleCloseAuth}
        title={"Image To PDF Converter"}
        content={<ImageToPDFConverter />}
      />

      <ModalView
        open={openForm}
        handleClose={handleCloseAuth}
        // title={"Image To PDF Converter"}
        content={<ContactForm onSuccess={() => { setOpenForm(false) }} />}
      />

    </ColorModeContext.Provider>
  );
}

export default SchoolDashboard;